<script setup>

</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 7.99996L8 10.6666L2 7.99996M14 10.6666L8 13.3333L2 10.6666M14 5.33329L8 7.99996L2 5.33329L8 2.66663L14 5.33329Z" stroke="#0084D1" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped>

</style>
